import { defineComponent as _defineComponent } from 'vue'
import _ from 'lodash'
import { createFsm } from 'machina'
import { E_AiHelperEvent, E_AiHelperState } from './AiHelper.types';

import active from '@/assets/aiChat/robot/active.gif'
import exit from '@/assets/aiChat/robot/exit.gif'
import entry from '@/assets/aiChat/robot/entry.gif'
import idle from '@/assets/aiChat/robot/idle.gif'
import static_ from '@/assets/aiChat/robot/static.png'

import { loginCounter } from '@/utils/storage';
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AiHelper',
  props: {
    state: null
  },
  emits: ["openAiChat", "updateState"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
    (e: 'openAiChat')
    (e: 'updateState', state: E_AiHelperState)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    state: E_AiHelperState
}






/// hack gif不重新播放!!!!
const gifUrl = entry; // 本地/同源GIF地址
const newEntryUrl = ref(null)
function loadGifAsBlob() {
    fetch(gifUrl)
        .then(response => response.blob())
        .then(blob => {
            const newUrl = URL.createObjectURL(blob);
            newEntryUrl.value = newUrl
        })
        .catch(err => console.error('加载失败：', err));
}
// 初始化加载
loadGifAsBlob();


const currentImage = computed(() => {
    return {
        [E_AiHelperState.Active]: active,
        [E_AiHelperState.Exit]: exit,
        [E_AiHelperState.Entry]: newEntryUrl.value || entry,
        [E_AiHelperState.Idle]: idle,
        [E_AiHelperState.Static]: static_,
    }[props.state]
})

const aiChatStateMachine = createFsm({
    id: 'aiChat',
    initialState: E_AiHelperState.Entry,
    context: {
        timer: null,
        timerEnabled: true,
    },
    states: {
        [E_AiHelperState.Entry]: {
            _onEnter({ ctx, emit }) {
                ctx.timer = setTimeout(() => {
                    aiChatStateMachine.handle(E_AiHelperEvent.Timeout)
                }, 60 * 1000)
            },
            _onExit({ ctx }) {
                if (ctx.timer !== null) {
                    clearTimeout(ctx.timer)
                    ctx.timer = null
                }
            },
            [E_AiHelperEvent.Click]: ({ ctx }) => {
                ctx.timerEnabled = false
                return E_AiHelperState.Active
            },
            [E_AiHelperEvent.Close]: E_AiHelperState.Closed,
            [E_AiHelperEvent.Drag]: E_AiHelperState.Static,
            [E_AiHelperEvent.Timeout]: E_AiHelperState.Idle,
        },
        [E_AiHelperState.Active]: {
            _onEnter({ ctx, emit }) {
                ctx.timer = setTimeout(() => {
                    aiChatStateMachine.handle(E_AiHelperEvent.Timeout)
                }, 4.06 * 1000)
            },
            _onExit({ ctx }) {
                if (ctx.timer !== null) {
                    clearTimeout(ctx.timer)
                    ctx.timer = null
                }
            },
            [E_AiHelperEvent.Close]: E_AiHelperState.Closed,
            [E_AiHelperEvent.Timeout]: E_AiHelperState.Static,
            [E_AiHelperEvent.Click]: E_AiHelperState.Static,
        },
        [E_AiHelperState.Exit]: {
            _onEnter({ ctx, emit }) {
                ctx.timer = setTimeout(() => {
                    aiChatStateMachine.handle(E_AiHelperEvent.Timeout)
                }, 6.65 * 1000)
            },
            _onExit({ ctx }) {
                if (ctx.timer !== null) {
                    clearTimeout(ctx.timer)
                    ctx.timer = null
                }
            },
            [E_AiHelperEvent.Timeout]: E_AiHelperState.Closed,
        },
        [E_AiHelperState.Idle]: {
            [E_AiHelperEvent.Click]: E_AiHelperState.Static,
            [E_AiHelperEvent.Close]: E_AiHelperState.Closed,
            [E_AiHelperEvent.Drag]: E_AiHelperState.Static,
        },
        [E_AiHelperState.Static]: {
            _onEnter({ ctx }) {
                if (!ctx.timerEnabled) {
                    return
                }
                ctx.timer = setTimeout(() => {
                    aiChatStateMachine.handle(E_AiHelperEvent.Timeout)
                }, 5 * 1000)
            },
            _onExit({ ctx }) {
                if (ctx.timer !== null) {
                    clearTimeout(ctx.timer)
                    ctx.timer = null
                }
            },
            [E_AiHelperEvent.Click]: ({ ctx }) => {
                clearTimeout(ctx.timer)
            },
            [E_AiHelperEvent.Close]: E_AiHelperState.Closed,
            [E_AiHelperEvent.ReActive]: ({ ctx }) => {
                clearTimeout(ctx.timer)
                ctx.timer = setTimeout(() => {
                    aiChatStateMachine.handle(E_AiHelperEvent.Timeout)
                }, 5 * 1000)
            },
            [E_AiHelperEvent.Timeout]: E_AiHelperState.Idle,
        },
        [E_AiHelperState.Closed]: {

        }
    },
})

const stub = aiChatStateMachine.on('transitioned', (data) => {
    console.log({ transitioned: data })
    emits('updateState', data.toState as E_AiHelperState)
})

emits('updateState', aiChatStateMachine.initialState as E_AiHelperState)

aiChatStateMachine.on('handled', data => {
    let enableTimer = data.inputName !== E_AiHelperEvent.Click;
    (aiChatStateMachine as any).context.timerEnabled = enableTimer
})

function onOpenAiChat() {
    aiChatStateMachine.handle(E_AiHelperEvent.Click)
    emits('openAiChat')
}

const aiHelperRef = ref<HTMLDivElement>(null)

const loginCC = loginCounter.get()
onMounted(() => {
    aiChatStateMachine.reset()
    if (loginCC === 1) {
        let dom = aiHelperRef.value
        dom.classList.add('animate')
    }
})

const showCloseBtn = computed(() => {
    return true
    return [E_AiHelperState.Idle, E_AiHelperState.Active, E_AiHelperState.Static].includes(props.state)
})

function onClose() {
    aiChatStateMachine.handle(E_AiHelperEvent.Close)
}

expose({
    fireEvent(event: E_AiHelperEvent) {
        aiChatStateMachine.handle(event)
    }
})


return { __sfc: true,props, emits, gifUrl, newEntryUrl, loadGifAsBlob, currentImage, aiChatStateMachine, stub, onOpenAiChat, aiHelperRef, loginCC, showCloseBtn, onClose }
}

})